import { render } from "./CustomSortableTable.vue?vue&type=template&id=340dc6b6&scoped=true"
import script from "./CustomSortableTable.vue?vue&type=script&lang=js"
export * from "./CustomSortableTable.vue?vue&type=script&lang=js"

import "./CustomSortableTable.vue?vue&type=style&index=0&id=340dc6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340dc6b6"]])

export default __exports__